import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

/**
 * Padrão 6: números monoespaçados e alinhados.
 *
 * Cada indicador é clicável e leva à listagem já filtrada — um número que você
 * não consegue abrir é um número que não ajuda a agir.
 */
export function Indicador({
  rotulo,
  valor,
  para,
  alerta = false,
  rodape,
}: {
  rotulo: string;
  valor: ReactNode;
  para?: string;
  alerta?: boolean;
  rodape?: ReactNode;
}) {
  const conteudo = (
    <>
      <span className="font-mono text-[0.6rem] tracking-[0.09em] text-tinta-3 uppercase">{rotulo}</span>
      <span className={`num text-2xl leading-tight font-semibold ${alerta ? 'text-pend' : ''}`}>
        {valor}
      </span>
      {rodape && <span className="text-[0.7rem] text-tinta-3">{rodape}</span>}
    </>
  );

  const classe =
    'flex flex-col gap-0.5 rounded-md border border-regua-2 bg-superficie px-3 py-2.5 transition-colors';

  return para ? (
    <Link to={para} className={`${classe} hover:border-marca hover:bg-marca/5`}>
      {conteudo}
    </Link>
  ) : (
    <div className={classe}>{conteudo}</div>
  );
}

export function GradeIndicadores({ children }: { children: ReactNode }) {
  return <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-3 xl:grid-cols-4">{children}</div>;
}
